import { makeReg4 } from './textStyles';
const linkStyles = (tokens) => ({
    baseStyle: {
        color: tokens.TextLink,
        textDecoration: 'underline',
        _hover: {
            color: tokens.TextLinkHover,
        },
        _focus: {
            outlineColor: tokens.BorderFocus,
        },
        _focusVisible: {
            shadow: 'none',
        },
    },
    variants: {
        'alert-warning': makeReg4(tokens, {
            color: tokens.TextDark800,
            textDecoration: tokens.TextDecorationUnderline,
        }),
        'alert-info': makeReg4(tokens, {
            color: tokens.TextInformation,
            textDecoration: tokens.TextDecorationUnderline,
        }),
        'alert-error': makeReg4(tokens, {
            color: tokens.TextError,
            textDecoration: tokens.TextDecorationUnderline,
        }),
        'alert-success': makeReg4(tokens, {
            color: tokens.TextSuccess,
            textDecoration: tokens.TextDecorationUnderline,
        }),
        grey: {
            color: tokens.TextDark800,
        },
        white: {
            color: 'white',
        },
        'no-underline': {
            textDecoration: 'none',
            color: tokens.TextDark800,
            _hover: {
                textDecoration: 'none',
            },
        },
    },
});
export default linkStyles;
